import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';
import { CheckboxInput } from 'component/Checkbox';
import { INDIRECT_EVIDENCE_LEGACY_OPTIONS, INDIRECT_EVIDENCE_V2_OPTIONS } from 'consts/Evidences';

export const IndirectEvidence = (props) => {
  const evidences = props.formData.info.evidences.indirect_evidences;
  const evidenceOptions = props.formData?.info?._schema_version === 2
    ? INDIRECT_EVIDENCE_V2_OPTIONS
    : INDIRECT_EVIDENCE_LEGACY_OPTIONS;

  const handleEvidenceInput = (value, isChecked) => {
    const evidenceTypes = [...(evidences.evidence_types ?? [])];

    if (isChecked) {
      if (!evidenceTypes.includes(value)) {
        evidenceTypes.push(value);
      }
    } else {
      const index = evidenceTypes.indexOf(value);
      if (index !== -1) {
        evidenceTypes.splice(index, 1);
      }
    }

    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        evidences: {
          ...prevFormData.info.evidences,
          indirect_evidences: {
            ...prevFormData.info.evidences.indirect_evidences,
            evidence_types: evidenceTypes,
          },
        },
      },
    }));
  };

  return (
    <AccordionBodyItem
      accordionSubId="4.4"
      titleUA="Непрямі докази"
      titleEN="Indirect evidence"
      children={(
        <div className="flex-group flex-wrap">
          {evidenceOptions.map((option) => (
            <CheckboxInput
              key={option.value}
              id={`indirect-evidence-${option.value}`}
              name={option.value}
              value={option.value}
              label={option.label}
              checked={evidences.evidence_types?.includes(option.value)}
              handleInput={handleEvidenceInput}
              disable="false"
            />
          ))}
        </div>
      )}
    />
  );
};
